<template>
    <div style="margin-bottom: -1rem">
        <apexchart ref="chart" type="line" height="350" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
    name: 'chart-line',

    components: {
        apexchart: VueApexCharts
    },

    props: {
        type: {
            type: String,
            default: 'today'
        },
        seriesData: {
            type: Array,
            default: () => {
                return []
            }
        },
        isConnection: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            series: [
                {
                    name: '',
                    data: []
                }
            ],
            chartOptions: {
                chart: {
                    height: 200,
                    type: 'line',
                    stacked: true,
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        dynamicAnimation: {
                            speed: 500
                        }
                    },
                    dropShadow: {
                        enabled: true,
                        opacity: 0.1,
                        blur: 5,
                        left: 0,
                        top: 18
                    },
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: false
                    }
                },
                xaxis: {
                    type: 'datetime'
                },
                tooltip: {
                    x: {
                        show: false,
                        format: 'HH:mm'
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth',
                    width: 5
                },
                grid: {
                    borderColor: '#eee'
                },
                markers: {
                    size: 0,
                    hover: {
                        size: 0
                    }
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        stops: [0, 100],
                        inverseColors: false,
                        gradientToColors: ['#7568f0']
                    }
                },
                colors: ['#f77695']
            },
            theme: {
                mode: null
            },
            modes: {
                dark: {
                    color: '#FFFFFF'
                },
                light: {
                    color: '#000000'
                }
            }
        }
    },

    watch: {
        seriesData() {
            this.setDataForSeries()
        },
        isDarkMode(val) {
            this.changeMode(val ? 'dark' : 'light')

            this.isDarkmode = val
        }
    },

    mounted() {
        this.setDataForSeries()
    },

    computed: {
        isDarkMode() {
            this.changeMode(this.$store.getters.isDarkMode ? 'dark' : 'light')
            return this.$store.getters.isDarkMode
        }
    },

    methods: {
        changeMode(value) {
            const style = value === 'dark' ? this.modes.dark.color : this.modes.light.color

            this.chartOptions = {
                ...this.chartOptions,
                ...{
                    theme: {
                        mode: value,
                        palette: 'palette1'
                    },
                    xaxis: {
                        ...this.chartOptions.xaxis,
                        labels: {
                            style: {
                                colors: style
                            }
                        }
                    }
                }
            }
        },

        setDataForSeries() {
            this.series = [
                {
                    name: '',
                    data: this.seriesData
                }
            ]

            let y = {
                formatter: function (y) {

                    if(typeof y !== "undefined") {
                        return y.toFixed(2);
                    }
                    return y;
                }
            }

            let yaxisFormat = {
                labels: {
                    formatter: (val) => {
                        return val.toFixed(2) + 'K'
                    }
                }
            }

            if (this.isConnection !== 'connection') {
                y = {
                    formatter: function (y) {
                        if(typeof y !== "undefined") {
                            return y.toFixed(2) + " KB";
                        }
                        return y;
                    }
                }

                yaxisFormat = {
                    labels: {
                        formatter: (val) => {
                            return val + 'KB'
                        }
                    }
                }
            }

            this.chartOptions = {
                ...this.chartOptions,
                tooltip: {
                    x: {
                        show: false,
                        format: 'dd/MM/yyyy'
                    },
                    y: y
                },
                yaxis: yaxisFormat,
            }
        }
    }
}
</script>
